import {
  tab_styles_default
} from "./chunk.K2HJIRPG.js";
import {
  SlTab
} from "./chunk.UH6ES2UT.js";
import {
  watch
} from "./chunk.UW2NVD5N.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  n
} from "./chunk.D5EJUUKV.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/tab/tab.ts
var FadvTab = class extends SlTab {
  handleActiveChange() {
    if (this.active) {
      emit(this, "sl-tab-activated", { detail: { name: this.panel } });
    } else {
      emit(this, "sl-tab-deactivated", { detail: { name: this.panel } });
    }
  }
};
FadvTab.styles = tab_styles_default;
__decorateClass([
  watch("active")
], FadvTab.prototype, "handleActiveChange", 1);
FadvTab = __decorateClass([
  n("fadv-tab")
], FadvTab);

export {
  FadvTab
};
